import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICustomer } from '../interfaces/customer';
import { ITestingModeImages } from '../interfaces/testingModeImages';
import { TestingModeResponse } from '../interfaces/testingModeResponse';

@Injectable({
	providedIn: 'root'
})
export class StoreService {
	toggleDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	customers$: BehaviorSubject<ICustomer[]> = new BehaviorSubject<ICustomer[]>([]);

	testingModeImages$: BehaviorSubject<ITestingModeImages> =
		new BehaviorSubject<ITestingModeImages>({
			dniFront: { image: '', file: null },
			dniBack: { image: '', file: null },
			selfieNeutral: { image: '', file: null },
			selfieGesture: { image: '', file: null }
		});

	testingModeIdOperacion$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	testingModeResponse$: BehaviorSubject<TestingModeResponse | null> =
		new BehaviorSubject<TestingModeResponse | null>({
			id_op: 99999,
			dni_front: {
				dni_side: 'front',
				img_quality: 'acceptable',
				suspicious: false
			},
			dni_back: {
				dni_side: 'back',
				img_quality: 'good',
				suspicious: false
			},
			selfies: [
				{
					id_selfie: 1,
					code: 100,
					match: true,
					emotions: {
						Enojado: 14.16,
						Disgustado: 0,
						Asustado: 23.95,
						Feliz: 2.84,
						Triste: 2.72,
						Sorprendido: 38.73,
						Neutral: 17.59
					},
					proof: true,
					suspicious: false,
					img_quality: 'acceptable'
				},
				{
					id_selfie: 2,
					code: 108,
					match: true,
					emotions: {
						Enojado: 0,
						Disgustado: 0,
						Asustado: 0,
						Feliz: 100,
						Triste: 0,
						Sorprendido: 0,
						Neutral: 0
					},
					proof: true,
					suspicious: false,
					img_quality: 'acceptable'
				}
			],
			readable_barcode: true,
			match_front_back: true,
			match_front_back_faces: true,
			match_ocr_barcode: true,
			context_match: true,
			extracted_data: {
				nombres: 'GABRIEL MAXIMILIANO',
				apellidos: 'BARRAZA',
				dni_numero: '41068725',
				ejemplar: 'A',
				sexo: 'M',
				fecha_nacimiento: '26/03/1998',
				fecha_emision: '06/02/2015',
				fecha_vencimiento: '<best_try>RENAFTER 06 FEB',
				nacionalidad: 'ARGENTINA',
				numero_tramite: '00341451737',
				dni_numero2: '41068725',
				domicilio: '37 519 LOCALIDAD BALCARCE BALCARCE',
				cuil: '23410687259',
				lugar_nacimiento: 'BUENOS AIRES',
				fecha_ingreso: null,
				categoria_ingreso: null,
				expediente: null,
				disposicion: null,
				fecha_radicacion: null,
				codigo_dorso: '9803260M3002061ARG BARRAZA IDARG41068725 GABRIEL 3 MAXIMILIANO 6'
			},
			ban_list_hit: false,
			control_ok: true,
			description: '41068725',
			renaper_answer: ''
		});

	contractBase64$: BehaviorSubject<string> = new BehaviorSubject<string>('');
	selfieEndpoint5$: BehaviorSubject<string> = new BehaviorSubject<string>('');

	constructor() {}

	toggleLoadingDialog(param: boolean): void {
		this.toggleDialog$.next(param);
	}

	setCustomers(customers: ICustomer[]): void {
		this.customers$.next(customers);
	}
}
